import React from "react";
import BSpinner from "../spinners/BSpinner";

const BLoadingIndicator = () => {
  return (
    <div className="p-6">
      <div className="bg-white rounded shadow-md mt-6 w-full">
        <div className="p-9 flex flex-col items-center justify-center">
          <div className="font-bold text-lg">Loading...</div>
          <BSpinner />
        </div>
      </div>
    </div>
  );
};

export default BLoadingIndicator;
